import { Injectable } from '@angular/core'; 

import { 
    CurrencyInterface,
    CurrencyModel, HttpStatusCodesEnum, LookupService, ServerResponse
} from '@spa/api';

import { Helper } from '../classes'; 
import { map } from 'rxjs/operators';


@Injectable()
export class CurrencyService {
    private allCurrencies: CurrencyModel[];

    constructor(private lookupService: LookupService) {
        this.allCurrencies = [];
    } 

    getAllCurrenciesAsync(): ServerResponse<CurrencyModel[]> {
        if (this.allCurrencies &&
            this.allCurrencies.length > 0) {
            return Helper.createSuccessResponseObservable<CurrencyModel[]>(this.allCurrencies);
        }

        return this.lookupService.getAllCurrencies().pipe(
            map(response => {
                if (response.status !== HttpStatusCodesEnum.Ok) {
                    return Helper.errorsHelper().createErrorResponse<CurrencyInterface[]>(response);
                }

                const invalidResponseCheck =
                    Helper.errorsHelper().checkForInvalidRespondedArray<CurrencyInterface>(response);

                if (!invalidResponseCheck) {
                    const data = response.data as CurrencyInterface[];

                    this.allCurrencies =
                        data.map(currency => new CurrencyModel(currency)); 
                }

                return Helper.createSuccessResponse<CurrencyModel[]>(this.allCurrencies);
            })
        );
    } 

    getAllCurrencies(): CurrencyModel[]{
        return this.allCurrencies;
    }
}
